import { NProductConfiguration } from '@df/module-product-configuration/df-module-product-configuration.interfaces';
import { ProductConfiguration } from '@df/module-product-configuration/model/product-configuration';
import { Nexus } from '@tomandco/nexus-api-types';
import { TCustomOption } from '../product-configuration-configurable-product-data.service';

class OptionWithValuesMultiSelection {
    get value(): boolean {
        return this.option.isSelected(this.data.value);
    }

    set value(to: boolean) {
        this.option.toggle(this.data.value, to);
    }

    get title() {
        return this.data.title;
    }

    get price() {
        return this.data.price;
    }

    constructor(
        private option: OptionWithValuesMulti,
        readonly data: Nexus.Lib.Catalog.Type.IProductDataCustomOptionSelection
    ) {}
}

export abstract class OptionWithValuesMulti {
    abstract type: string;

    private selection: number[] = [];

    readonly values: OptionWithValuesMultiSelection[];

    toggle(selectionValue: number, to = !this.isSelected(selectionValue)): void {
        const index = this.selection.indexOf(selectionValue);
        if (to) {
            if (index === -1) {
                this.selection.push(selectionValue);
            }
        } else {
            if (index !== -1) {
                this.selection.splice(index, 1);
            }
        }
        this.sanitize();
        this.configuration.customOptionsDataChange$.next(this as TCustomOption);
    }

    isSelected(selectionValue: number): boolean {
        return this.selection.includes(selectionValue);
    }

    constructor(
        private configuration: ProductConfiguration,
        readonly data: Nexus.Lib.Catalog.Type.IProductDataCustomOption
    ) {
        this.values = data.values!.map(value => new OptionWithValuesMultiSelection(this, value));
    }

    toRequest(): { key: number; value: number[] } | undefined {
        if (this.selection.length) {
            return {
                key: this.data.id,
                value: this.selection
            };
        }
        return undefined;
    }

    sanitize() {
        this.selection = this.selection
            .map(i => {
                if (typeof i === 'string') {
                    i = Number(i);
                }
                if (this.values.find(j => j.data.value === i)) {
                    return i;
                }
                return undefined;
            })
            .filter(i => !!i) as number[];
    }

    validate(): NProductConfiguration.Error.Entry | undefined {
        if (this.data.req && !this.selection.length) {
            return {
                code: NProductConfiguration.Error.Code.missing,
                level: NProductConfiguration.Error.Level.error,
                fieldName: this.data.title
            };
        }
    }
}
